import React, { useState, useEffect} from "react";
import axios from "axios";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useNavigate } from 'react-router-dom';

const Service = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const serviceID = urlParams.get('id');
    const navigate = useNavigate();
	const [expenses, setExpenses] = useState([]);
    const [formData, setFormData] = useState({
        service: '',
        hsn: '',
        date: '',
        charges: '',
        id: serviceID,
    });

    // Fetching Data
    useEffect(() => {
        axios.get("https://api.trucoo.in/service/addservice/")
            .then(response => {
                setExpenses(response.data)
				console.log("Form Submitted: ", response.data);
            })
            .catch(error => {
                console.error("There was an error in Fecthing Data", error)
            })
    }, []);
    console.log(expenses);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        

        console.log("Form Submitted: ", formData);

        // Fetch functionality
        axios.post('https://api.trucoo.in/service/addservice/', formData, {

            headers: {
                'Content-Type': 'application/json'
            }

        })
            .then(response => {
                if (response.data.status === "success") {
                       navigate(`/invoice`);
                  } else {
                    console.error(response.data);
                  }

            })
            .catch(error => {
                console.error("There was an Error");
            });

        console.log('Form Data:', formData);

    }
    return(

        <>
        <Header />
        <Sidebar />


        <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<div class="row">
                       
					<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Service</h4>
								    <hr class="my-15" />

								    <div class="row">

										

                                        {/* category*/}
								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Service</label>
									            <input type="text" class="form-control" name="service" value={formData.service} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}
                                         {/* category*/}
								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">HSN</label>
									            <input type="text" class="form-control" name="hsn" value={formData.hsn} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}

                                        {/* category*/}
								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">charges</label>
									            <input type="text" class="form-control" name="charges" value={formData.charges} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}
                               

										{/* date */}
								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Date</label>
									            <input type="date" class="form-control" name="date" value={formData.date} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the date*/}

										 

								    </div>
                        
                                </div>
                            </div>
                        </div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
							        <div class="box-footer" align="center">
								        <button type="button" class="btn btn-primary-light me-1"><i class="ti-trash"></i> Cancel</button>
								        <button type="submit" class="btn btn-primary" onClick={handleSubmit}><i class="ti-save-alt"></i> Save</button>
										    </div>  
						
					            </div>
						    </div>
						</div>
                     
					</div>
				</div>
			</section>
		</div>
	</div>


        </>
    )

    
}

export default Service;